@if (plan(); as p) {
  <div class="flex flex-col gap-4">
    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-100 text-violet-600">
          <i class="pi pi-info-circle text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Información general</span>
      </div>
      <div class="p-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div class="sm:col-span-2">
            <p class="text-xs font-medium text-slate-500">Nombre</p>
            <p class="text-sm font-semibold text-slate-900">{{ p.name || '—' }}</p>
            @if (p.description) {
              <p class="text-xs text-slate-500 mt-0.5">{{ p.description }}</p>
            }
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Estado</p>
            <p-tag
              class="text-xs"
              [severity]="getStatusSeverity(p.status)"
              [value]="getStatusLabel(p.status)" />
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Frecuencia</p>
            <p-tag
              severity="secondary"
              class="text-xs"
              [value]="getFrequencyLabel(p.frequency)" />
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Subtotal</p>
            <p class="text-sm text-slate-700 tabular-nums">
              {{ (p.subtotal ?? 0) | currency:(p.currency || 'MXN'):'symbol':'1.2-2' }}
            </p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Impuestos</p>
            <p class="text-sm text-slate-700 tabular-nums">
              {{ (p.tax ?? 0) | currency:(p.currency || 'MXN'):'symbol':'1.2-2' }}
            </p>
          </div>
          @if ((p.discount ?? 0) > 0) {
            <div>
              <p class="text-xs font-medium text-slate-500">Descuento</p>
              <p class="text-sm text-slate-700 tabular-nums">
                {{ p.discount | currency:(p.currency || 'MXN'):'symbol':'1.2-2' }}
              </p>
            </div>
          }
          <div>
            <p class="text-xs font-medium text-slate-500">Total</p>
            <p class="text-sm font-semibold text-slate-900 tabular-nums">
              {{ (p.total ?? 0) | currency:(p.currency || 'MXN'):'symbol':'1.2-2' }}
            </p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Moneda</p>
            <p class="text-sm text-slate-700">{{ p.currency || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Fecha de creación</p>
            <p class="text-sm text-slate-700">{{ p.createdAt ? (p.createdAt | date:'dd/MM/yyyy') : '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Última actualización</p>
            <p class="text-sm text-slate-700">{{ p.updatedAt ? (p.updatedAt | date:'dd/MM/yyyy') : '—' }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
          <i class="pi pi-list text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Items ({{ p.items?.length ?? 0 }})</span>
      </div>
      @if (p.items?.length) {
        <div class="divide-y divide-slate-100">
          @for (item of p.items; track item.id ?? $index) {
            <div class="flex items-start gap-2 px-4 py-2">
              <div class="min-w-0 flex-1">
                <span class="text-xs font-medium text-slate-900 truncate">
                  {{ item.description || 'Sin descripción' }}
                </span>
                @if (item.quantity != null && item.unitPrice != null) {
                  <p class="text-xs text-slate-500 mt-0.5">
                    {{ item.quantity }} × {{ item.unitPrice | currency:(p.currency || 'MXN') }}
                  </p>
                }
              </div>
              <span class="shrink-0 text-xs font-bold text-slate-900 tabular-nums">
                {{ (item.totalAmount ?? 0) | currency:(p.currency || 'MXN'):'symbol':'1.2-2' }}
              </span>
            </div>
          }
        </div>
      } @else {
        <p class="text-sm text-slate-500 px-4 py-3">Sin items registrados.</p>
      }
    </div>
  </div>
}
